var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('CircleButton',{attrs:{"icon":"random","title":"Generate Word"},nativeOn:{"click":function($event){return _vm.generate($event)}}}),_c('h4',[_vm._v(_vm._s(_vm.word))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }